import React from 'react'

import CloseIcon from '../../../../components/Icons/CloseIcon';

interface ModalProps {
    title: string;
    description: string;
}

const Modal = (props: ModalProps) => {

    const { title, description } = props;

    return (
        <div id="hs-basic-modal" className="shadow-custom-shadow hs-overlay hs-overlay-open:opacity-100 hs-overlay-open:duration-500 hidden fixed inset-0 z-80 flex items-center justify-center opacity-0 transition-all pointer-events-none">
            {/* Backdrop */}
            <div className="fixed inset-0 bg-gray-900 bg-opacity-80 hs-overlay-backdrop"></div>
            
            {/* Modal content */}
            <div className="sm:max-w-lg sm:w-full m-3 relative z-90">
                <div className="flex flex-col bg-neutral-800 border-neutral-700 shadow-neutral-700/70 border shadow-sm rounded-xl pointer-events-auto">
                    <div className="flex justify-between items-center p-4 border-b border-neutral-600">
                        <h3 className="text-lg font-medium text-white">
                            {title}
                        </h3>
                        <button type="button" className="flex justify-center items-center size-7 text-sm font-semibold rounded-full border border-transparent text-white hover:bg-neutral-700 disabled:opacity-50 disabled:pointer-events-none" data-hs-overlay="#hs-basic-modal">
                            <span className="sr-only">Close</span>
                            <CloseIcon aria-hidden="true" className="h-5 w-5 text-white!" />
                        </button>
                    </div>
                    <div className="p-4 overflow-y-auto">
                        <p className="mt-1 text-neutral-400">
                            {description}
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Modal